import CxIconVariant from '../../cx/CxIconVariant';
import { FaUser } from "react-icons/fa"; 
import { BsFillSendFill, BsCheck } from "react-icons/bs"; 
import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxSearcher from '../../cx/CxSearcher';
import CxDate from '../../cx/CxDate';
import CxIcon from '../../cx/CxIcon';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxDat from '../../fx/FxDat';
import { StoreClient } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';
import { clearStore, StoreComm, StoreRepl, getStoreValueBo } from "../../gx/GxStore";
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import { useAccess } from '../../hx/useAccess';
import GxSlsAuxTable from '../../gx/GxSlsAuxTable';
import CxStatic from '../../cx/CxStatic';
import * as FxFetch from '../../fx/FxFetch';


const MxClientReplForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.repls'));
  const [{ navTo, navStack }] = useNav();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const [storeClient, ] = useSessionStorage('StoreClient', StoreClient);
  const [storeComm, setStoreComm] = useSessionStorage('StoreComm', StoreComm);
  const [storeRepl, setStoreRepl] = useSessionStorage('StoreRepl', StoreRepl);

  let r_form = React.useRef(null);
  let r_sls_aux_table = React.useRef(null);

  const rf_ps = React.useRef(null);
  const rf_date = React.useRef(null);
  const rf_next = React.useRef(null);
  
  const r_snack_ask_save = React.useRef(null);
  const r_snack_ps_doesnt_exist = React.useRef(null);


  React.useEffect(() => {
    clearStore('StoreComm', storeComm);
    // eslint-disable-next-line
  }, []);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
      r_form.current.getRef("n_repl.dtFrom").setValToday();
      rf_ps.current.search(); /* DAQ 2026.05.04 - abre automáticamente ventana de selección de tipo de p-s */
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theValue.startsWith("rv_")) {
      // errores al guardar
      if (lastSaveRv.theValue.startsWith("rv_ps_doesnt_exist")) {
        r_snack_ps_doesnt_exist.current.setOpen(true);
      }
    } else {
      // se guardó exitosamente
      storeRepl.inRepl = lastSaveRv.theValue;
      Promise.all([setStoreRepl(storeRepl)]).then((result) => {
        r_sls_aux_table.current.setTxLinkAuxId(storeRepl.inRepl);
        forceUIUpdate();
        //navBack(); // 2024-07-02 - daq: xq puede querer añadir ps o recordatorio.
      });
    }

  }
  const formDelete = async (rv) => {
  }

  const openFormComm = () => {
    if (storeRepl.inRepl) {

      let record = {};
      record['inRepl'] = storeRepl.inRepl;
      Promise.all([FxFetch.doJsonX('comms/get_inComm_from_inRepl', record)]).then((result) => {
        if (result[0]) {
          FxLog.infox('MxClientReplForm.openFormComm', '...result[0]:', result[0]);
          if (result[0].theValue) {
            // ya hay una comunicación para este evento-calendario, así que la cargamos
            storeComm.inComm = result[0].theValue;
            setStoreComm(storeComm);
            navTo("comm-form");
          } else {
            // no hay una comunicación, así que preparamos form para crear una nueva
            storeComm.inComm = null;
            storeComm.inPs = rf_ps.current.getKey();
            storeComm.inClient = storeClient.inClient;
            storeComm.inRepl = storeRepl.inRepl;
            storeComm.dtFrom = `${rf_next.current.getVal()} 00:00`;

            let record = {};
            Promise.all([FxFetch.doJsonX('sett/autogen/r', record)]).then((result) => {
              if (result[0].length > 0) {
                let txContent = result[0][0].txContent;
                txContent = txContent.replace('[name]', storeClient.txClient);
                txContent = txContent.replace('[ps]', rf_ps.current.getVal());

                let record2 = {};
                record2['idValue'] = rf_ps.current.getKey();
                Promise.all([FxFetch.doJsonX("pss/r", record2)]).then((result) => {
                  if (result[0]) {
                    FxLog.infox('MxClientReplForm.openFormComm', '...result[0]:', result[0]);
                    txContent = txContent.replace('[alias]', result[0][0].txPsAlias);
                    storeComm.txContent = txContent;
                    setStoreComm(storeComm);
                    navTo("comm-form");
                  }
                });
              }
            });
          }
        }
      });

    } else {
      r_snack_ask_save.current.setOpen(true);
    }
  }

  const psChanged = async (row) => {
    if (row !== null) {
      let nuFrequency = row.original.nuFrequency;
      let next = FxDat.addDays(rf_date.current.getVal(), nuFrequency);
      rf_next.current.setVal(next);
    }
  }

  const openFormClient = () => {
    // Abrir en nueva pestaña si el sistema está disponible, o navegar
    // directamente como fallback (móvil / pestañas desactivadas).
    if (getStoreValueBo('StoreSession', 'boShowTabs')) {
      window.__mxMain_openTabWithNavigation('client-form', storeClient.txClient || trans('field.client'), false);
    } else {
      navTo('client-form');
    }
  };

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.client')}: ${trans('field.repl')}`}
        xref={r_form}
        url="repls" 
        filterIdField='inRepl' 
        filterIdValue={storeRepl.inRepl} 
        onFormLoad={formLoad} 
        onFormSave={isFullAccess() && formSave} 
        onFormDelete={isFullAccess() && formDelete} 
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>

            {/* botón de comm */}
            {storeRepl.inRepl && isFullAccess() && (
              <CxIconButtonNew 
                icon={
                  <CxIcon 
                    frontIcon={Boolean(storeRepl.boComm==='1') ? <BsCheck /> : null} 
                    frontSize="12px"
                    frontPos={{ bottom: "-2px", right: "-2px" }}
                    frontShell="circle"
                    frontShellColor="yellow"
                    frontColor="var(--ibs_color_black_dark)"
                    backIcon={<BsFillSendFill />} 
                    backSize="20px"
                    backColor="var(--ibs_color_cy_blue)"
                  />
                } 
                classType="ibs_iconbutton_toolbar" 
                onClick={openFormComm} 
                tooltip={trans('field.comm')} 
              />
            )}

            {storeRepl.inRepl && navStack()[navStack().length-2]==='activity-opti-r-list' && <CxIconButtonNew 
              icon={getStoreValueBo('StoreSession', 'boShowTabs') ? (<CxIconVariant variant="client-go" />) : (<FaUser fontSize={19} style={{ margin: '2px 0 0 0px' }} />)} 
              classType="ibs_iconbutton_toolbar" onClick={openFormClient} tooltip={trans('field.open_x', 'field.client')} 
            />}
          </div>
        }
        >
        <CxHidden xref={useRef(null)} dbfield="n_repl.inClient" value={storeClient.inClient || ''} />

        <CxStatic label={`${storeClient.txClient}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />

        <CxSearcher xref={rf_ps} label={trans('field.ps')}
          dbfield="n_ps.txPs" dbfieldkey={`n_repl.inPs`}
          filter={'n_ps.nuFrequency > 0'}
          onSelection={psChanged}
          url="pss"
          col_id="inPs"
          col_tx="txPs"
          columns={[
            { id: "0", Header: "ID", accessor: "inPs", show: false },
            { id: "1", Header: trans('field.ps'), accessor: row => rf_ps.current.getTable().highlightText(row["txPs"]), width: '100%' },
            { id: "2", Header: trans('field.frequency'), accessor: "nuFrequency", show: false },
          ]}
          required
        />

        <CxDate xref={rf_date} label={trans('field.date')} dbfield="n_repl.dtFrom"/>
        <CxDate xref={rf_next} label={trans('field.next')} dbfield="n_repl.dtNext"/>
        
      </GxForm>

      <GxSlsAuxTable xref={r_sls_aux_table} txLinkAuxTable={'n_repl'} txLinkAuxId={storeRepl.inRepl} /* rf_txEmployee={rf_txEmployee} */ />

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />
      <CxSnackbar xref={r_snack_ps_doesnt_exist} severity="error" value={trans('msg.x_doesnt_exist_1','field.product')} />
      
    </div>
  );

}

export default MxClientReplForm;
